module.exports = __webpack_public_path__ + "a2b0825e9d872ffbfa4e119b0f45a86e.svg";